import React, { Component } from 'react';
import { Button, Row, Col, Container } from 'reactstrap';
import config from '../../../config/app.config';
import { AvatarModal } from '../../../shared/components/Modals/AvatarModal';

const defautAvatar = `${process.env.PUBLIC_URL}/img/defaultAvatar.png`;

const SUPER_ADMIN = config.USER_TYPES.SUPER_ADMIN;
const STAFF = config.USER_TYPES.STAFF;

export default class AvatarSection extends Component {
  constructor(props) {
    super(props);

    this.state = { showImageCrop: false };
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (np.profile) {
      const {
        type,
        firstName,
        lastName,
        username,
        designation,
        avatar,
      } = np.profile;
      this.setState({
        type,
        firstName,
        lastName,
        username,
        designation,
        avatar,
      });
    }
  }

  selectFile = () => {
    this.setState({ showImageCrop: true });
  };

  closeUploadModal = () => {
    this.setState({ showImageCrop: false });
  };

  cropAndUpload = async (img) => {
    this.props.upload(img);
    this.setState({ showImageCrop: false });
  };

  getDisplayName = () => {
    const firstName = (this.state.firstName || '').trim();
    const lastName = (this.state.lastName || '').trim();
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }
    return this.state.username || '';
  };

  render() {
    const { type, designation, avatar, showImageCrop } = this.state;

    const title =
      type === SUPER_ADMIN
        ? 'Super Admin'
        : type === STAFF
          ? (designation && designation.name) || 'User'
          : 'Admin';

    return (
      <div className="user-profile__avatar-sestion">
        <AvatarModal
          isOpen={showImageCrop}
          onCancel={this.closeUploadModal}
          onDone={this.cropAndUpload}
          src={avatar}
        />

        <Container>
          <Row>
            <Col xs="1">
              <div className="topbar__avatar-img ">
                <img src={avatar || defautAvatar} alt="avatar" />
              </div>
            </Col>
            <Col xs="10">
              <div className="user-profile__avatar-details-section">
                <p className="user-profile__avatar-details-section--name">
                  {this.getDisplayName()}
                </p>
                <p className="user-profile__avatar-details-section--post">
                  {title}
                </p>
                <Button
                  onClick={this.selectFile}
                  className="user-profile__avatar-details-section--upload-btn"
                  color="primary"
                >
                  <span className="lnr lnr-plus-circle" />{' '}
                  <span className="text">Update Avatar</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
